// 通讯录
import {nextTick} from 'vue'
import {getUser} from '@/api/system/user.js'
import {getMyGroupsByIdApi, pageMyGroupsApi} from '@/api/system/my-groups-api.js'
import useUserStore from '@/store/modules/user'

const useContactUserStore = defineStore('contactUser', {
    state: () => ({
        visibleContactPop: false,
        placement: 'right',
        contactPopRef: null,
        contactTemRef: null,
        contactData: null,
        groupList: [], // 存放用户分组，节省请求
        contactBook: new Array()// 存放 通讯录信息，用于流程模块里点击名字查看用户信息
    }),
    actions: {
        // 分组成员 浮窗
        showContactPopover(e, row) {
            // 通过设置false 销毁poppover, 解决闪现问题
            this.placement=row.placement||'right'
            if (this.contactTemRef) this.visibleContactPop = false
            nextTick(() => {
                this.contactTemRef = e?.currentTarget
                this.visibleContactPop = true
                this.getContactBook(row.userId).then(res=>{
                    this.contactData = res
                })
            }).then()
        },
        // 根据组id 获取分组详情信息，用于展示 分组成员
        async getGroupDetailById(row) {
            const res = await getMyGroupsByIdApi(row.id).catch(e => {
                console.error(e)
                return null
            })
            if (res?.data) Object.assign(row, res.data)
        },
        clearGroupList(){
            this.groupList.length = 0
        },
        // 根据用户id 加载我的分组数据（没有pageSize参数时会展示所有的分组）
        async getGroupList() {
            if (this.groupList.length || !useUserStore().userInfo.userId) {
                return
            }
            try {
                const res = await pageMyGroupsApi({pageNum: 1, status: 0, createBy: useUserStore().userInfo.userId})
                if (!res?.rows?.length) {
                    return []
                }
                // 并发获取详情
                await Promise.allSettled(res.rows.map(this.getGroupDetailById))
                let test = res.rows.flatMap(item => item.sysUsers)
                // const keys=['createTime', 'delFlag','loginDate','loginIp','updateTime','password','remark','createBy','updateBy']
                const useKeys = ['userId', 'userName', 'nickName', 'deptId', 'dutyId', 'email', 'phonenumber', 'sex', 'avatar', 'status', 'dept', 'roles', 'roleIds', 'postIds', 'roleId', 'admin']
                const result = []
                test.forEach(u => {
                    let r = {}
                    const hasRepeat = result.some(i => i.userId === u.userId)
                    if (!hasRepeat) {
                        useKeys.forEach(k => {
                            r[k] = u[k]
                        })
                        result.push(r)
                    }
                })
                this.groupList = res.rows
                this.contactBook = result
                return result
            } catch (e) {
                console.error(e)
            }
        },
        // 获取通讯录里的用户信息
        async getContactBook(userId) {
            if (!userId) {
                return null
            }
            let result = this.contactBook.find(i => i.userId === userId)
            if (!result) {
                try {
                    const res = await getUser(userId)
                    result = res.data
                    this.setContactBook(res.data)
                } catch (e) {
                    console.error(e)
                }
            }
            this.contactData = result
            return result
        },
        // 清空通讯录里的用户信息
        clearContactData() {
            this.contactData = null
        },
        // 更新用户信息时要移除pinia中的缓存，避免数据没有更新的问题
        removeContactBook(userId) {
          const index= this.contactBook.findIndex(i => i.userId === userId)
            if(index>-1){
                this.contactBook.splice(index,1)
            }
        },
        // 设置通讯录里的用户信息
        setContactBook(userArr) {
            let arr = []
            if (Array.isArray(userArr) ) {
                arr = userArr
            }else{
                arr.push(userArr)
            }
            arr.forEach(item => {
                const hasRepeat = this.contactBook.some(i => i.userId === item.userId)
                if (!hasRepeat) {
                    this.contactBook.push(item)
                }
            })
        }
    }
})
export default useContactUserStore

